import React from "react";
import InstructorList from "@/components/CourseContent/ContentRefresh/InstructorList";
import WhatYoullLearn from "@/components/CourseContent/ContentRefresh/WhatYoullLearn";
import AccordionText from "@/components/AccordionText";
import AccordionTextItem from "@/components/AccordionText/AccordionTextItem";
import { CollapsedContentProps } from "./types";
import CourseAwards from "@/components/CourseContent/templates/components/Awards";
import SkillLanguageOverview from "@/components/CourseContent/ContentRefresh/SkillLanguageOverview";
import BenefitList from "@/components/BenefitList";
import { defaultBenefits } from "./constants";
import { hasValidAwards } from "@/components/CourseContent/templates/common/utils/validAwards";
import useTranslations from "@/i18n/useTranslations";

const CollapsedContent = (props: CollapsedContentProps) => {
  const t = useTranslations("Course");
  const tCommon = useTranslations("Common");
  // Check if awards are valid
  const hasAwards =
    props.awards &&
    props.awards.awards &&
    props.awards.awards.length > 0 &&
    hasValidAwards(props.awards.awards);

  const benefits = props.benefitsList?.benefits || defaultBenefits;
  const hasBenefits = benefits && benefits.length > 0;

  return (
    <div className="flex flex-col lg:grid lg:grid-cols-5 gap-6 -mt-6">
      {/* First Column - Accordions */}
      <div className="flex flex-col gap-6 lg:col-span-3">
        <AccordionText variant="value-oriented-content" title="">
          {props.whatYoullLearn && (
            <AccordionTextItem
              variant="value-oriented-content"
              trigger={t("whatYoullLearn")}
            >
              <WhatYoullLearn
                key="whatYoullLearn"
                {...props.whatYoullLearn}
                oneColumn={true}
              />
              {props.skillLanguageOverview && (
                <div className="pt-6 flex flex-col gap-6">
                  <SkillLanguageOverview
                    {...props.skillLanguageOverview}
                    oneColumn={true}
                  />
                </div>
              )}
            </AccordionTextItem>
          )}

          {props.instructorsList &&
            props.instructorsList.instructors.length > 0 && (
              <AccordionTextItem
                variant="value-oriented-content"
                trigger={t("meetTheInstructors")}
              >
                <InstructorList
                  {...props.instructorsList}
                  showSingleColumn={true}
                  hideTitle={true}
                />
              </AccordionTextItem>
            )}
        </AccordionText>
      </div>

      {/* Second Column - Award or benefit list */}
      <div className="flex flex-col gap-6 w-full lg:col-span-2">
        {hasAwards && (
          <CourseAwards
            key="courseAwards"
            awards={props.awards!.awards}
            isSpanish={false}
            width={103}
            height={103}
            title={t("awardWinningCourse")}
            className="text-center flex flex-col items-center [&_h2]:!text-2xl"
          />
        )}
        {!hasAwards && hasBenefits && (
          <BenefitList
            benefits={benefits}
            title={props.benefitsList?.title || tCommon("whyTakeThisCourse")}
          />
        )}
      </div>
    </div>
  );
};

export default CollapsedContent;
